module.exports = __webpack_public_path__ + "img/huati.fe457de7.svg";